
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import Services from './components/Services';
import Stats from './components/Stats';
import CTA from './components/CTA';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <Stats />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
